import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'

import VfText from '../../VfText'

import styles from './RadioButton.Styles'

function RadioButton(props) {

    const {
        id,
        label,
        isActive,
        optionStyle,
        activeOptionStyle,
        labelStyle,
        activeLabelStyle,
        setSelected,
        disabled,
        isLoading,
    } = props

    return (
        <TouchableOpacity
            disabled={disabled || !setSelected}
            onPress={() => setSelected(id)}
            style={[styles.option, optionStyle, isActive && activeOptionStyle]}
            activeOpacity={0.5}
        >
            <View style={[styles.outer, styles['outer_isActive_' + isActive]]}>
                <View style={[styles.inner, styles['inner_isActive_' + isActive]]} />
            </View>
            <VfText
                i18nKey={label || ''}
                loaderWidth={120}
                isLoading={isLoading}
                style={[
                    styles.label,
                    labelStyle,
                    isActive && activeLabelStyle,
                ]}

            />
        </TouchableOpacity>
    )
}

RadioButton.defaultProps = {
    label: '',
    isActive: false,
    optionStyle: {},
    activeOptionStyle: {},
    labelStyle: {},
    activeLabelStyle: {},
    setSelected: () => { },
    disabled: false,
}

RadioButton.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    label: PropTypes.string,
    isActive: PropTypes.bool,
    optionStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    activeOptionStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    labelStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    activeLabelStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    setSelected: PropTypes.func,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
}

export default RadioButton
